module.exports = __webpack_public_path__ + "img/thinking-out-loud.c7cf42cd.jpg";